import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { MapsState } from './maps.types';
import { getProjectMaps, updateMap } from './maps.thunks';

export const getProjectMapsReducer = (builder: ActionReducerMapBuilder<MapsState>): void => {
  builder
    .addCase(getProjectMaps.pending, state => {
      state.loading = 'pending';
      state.error = null;
    })
    .addCase(getProjectMaps.fulfilled, (state, action) => {
      state.loading = 'succeeded';
      state.data = action.payload;
      state.error = null;
    })
    .addCase(getProjectMaps.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.payload as { name: string; message: string };
    });
};

export const updateMapReducer = (builder: ActionReducerMapBuilder<MapsState>): void => {
  builder
    .addCase(updateMap.pending, (state, action) => {
      const { mapId } = action.meta.arg;
      state.updateLoading[mapId] = 'pending';
    })
    .addCase(updateMap.fulfilled, (state, action) => {
      const updatedMap = action.payload;
      const mapId = updatedMap.idObject;

      // Update the map in the data array
      const NOT_FOUND_INDEX = -1;
      const index = state.data.findIndex(map => map.idObject === mapId);
      if (index !== NOT_FOUND_INDEX) {
        state.data[index] = updatedMap;
      }

      state.updateLoading[mapId] = 'succeeded';
    })
    .addCase(updateMap.rejected, (state, action) => {
      const { mapId } = action.meta.arg;
      state.updateLoading[mapId] = 'failed';
    });
};
